module.exports = __webpack_public_path__ + "img/zk-pic.d84a0767.jpg";